// extracted by mini-css-extract-plugin
module.exports = {"button":"style_button__pGtec","selected":"style_selected__oEzOS","menu":"style_menu__Kdt09","switcher":"style_switcher__DgQkd"};